import { useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { stoolToGut } from 'helpers';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { KitType } from '@repo/types';

export function getInsightCategoryDetail(kitId: string, categoryId: number) {
  const res = API.get(
    apiName,
    `${apiBasePath}/results/kitInsightDetailWithTaxaById/${kitId}/${categoryId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.INSIGHTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
        categoryId,
      },
    },
  );
  return res;
}

const useInsightCategoryDetailById = (categoryId: number) => {
  const { currentKitId, currentKitType } = useCurrentKitAndTinyAccount();
  const insightsDataQuery = useQuery({
    queryKey: [
      apiName,
      `${stoolToGut(currentKitType ?? KitType.STOOL)}InsightDetail`,
      currentKitId,
      categoryId,
    ],
    queryFn: () =>
      currentKitId && getInsightCategoryDetail(currentKitId, categoryId),
  });

  return insightsDataQuery;
};

export default useInsightCategoryDetailById;
